import { COACHING_BACKOFFER_PLAN_IDS, COACHING_PLAN_IDS } from '@/modules/upsell/domain/prices/coach';
const EXCLUSION_GROUPS = {
    coaching: new Set([...Object.values(COACHING_PLAN_IDS), ...Object.values(COACHING_BACKOFFER_PLAN_IDS)]),
};
function findExclusionGroup(orderId) {
    for (const [groupName, memberIds] of Object.entries(EXCLUSION_GROUPS)) {
        if (memberIds.has(orderId))
            return { name: groupName, memberIds };
    }
    return null;
}
export { EXCLUSION_GROUPS, findExclusionGroup };
